import Vue from "vue";
import Vuex from "vuex";
import sidebar from "./modules/sidebar";
import rekamMedis from "./modules/rekamMedis";
import { SuratPenunjangStore } from "./modules/SuratPenunjangStore";
import struk from "./modules/struk";
import SecureLS from 'secure-ls';
import VuexPersist from "vuex-persist";

// Load Vuex
Vue.use(Vuex);

const ls = new SecureLS({ isCompression: true });

const vuexPersist = new VuexPersist({
  key: "_izd_",
  storage: window.localStorage
});

const getRoles = state => state && state.user && state.user.roles;

// Create store
export default new Vuex.Store({
  state: {
    URL_API: process.env.VUE_APP_API_URL,
    BEARER_TOKEN: null,
    user: null,
    loading: false,
    autherror: null,
    initPosition: null,
    uploadPasien: null,
    uploadBhp: null,
    uploadObat: null,
    klinikUser: null,
    roles: null,
    faskes: null,
    klinikId: null,
    dokterId: null,
    bpjsAuthValid: false,
    satusehatAuthValid: false,
    isFaskesDpm: false,
    verificationProfileId: null
  },
  modules: {
    sidebar,
    rekamMedis,
    struk,
    SuratPenunjangStore
  },
  getters: {
    isLoading: (state) => state.loading,
    userRole: getRoles,
    doctorRole: state =>
      getRoles(state).some(val => /(dokter|doktor)/gi.test(val.name)),
    assistantRole: state =>
      getRoles(state).some(val => /(asisten|operator)/gi.test(val.name)),
    getInitiationPosition: (state) => state.initPosition,
    isFirstLogin: (state) => (state.user && state.user.is_first_login) == 1,
    getKlinikId: (state) => state.klinikId,
    getRolesName: state => {
      let roles = [];
      state.roles.forEach(role => {
        roles.push(role.name)
      })
      return roles;
    },
    uploadPasien: (state) => state.uploadPasien,
    uploadBhp: (state) => state.uploadBhp,
    uploadObat: (state) => state.uploadObat,
    klinikUser: (state) =>  state.klinikUser,
    faskes: (state) => state.faskes,
    getDokterId: (state) => state.dokterId,
    getIdKlinikDokter: (state) => {
      const dokter = state.roles.filter(role => {
        return role.name == "dokter_klinik"
      });
      return dokter[0].pivot.model_id;
    },
    bpjsAuthValid: (state) => state.bpjsAuthValid,
    satusehatAuthValid: (state) => state.satusehatAuthValid,
    getFaskesType: (state) => state.isFaskesDpm,
    getVerificationProfileIf: (state) => state.verificationProfileId
  },
  mutations: {
    SET_BEARER_TOKEN(state, value) {
      state.BEARER_TOKEN = value;
    },
    SET_USER(state, value) {
      state.user = value;
    },
    SET_LOADING(state, value) {
      state.loading = value || false;
    },
    SET_AUTHERROR(state, value) {
      state.autherror = value || null;
    },
    SET_USER_FIRST_LOGIN(state, value) {
      state.user.is_first_login = value;
    },
    SET_INIT_POSITION(state, value) {
      state.initPosition = value;
    },
    SET_IDLE(state, value) {
      state.idleVue.isIdle = value;
    },
    SET_UPLOAD_PASIEN(state, value) {
      state.uploadPasien = value
    },
    SET_UPLOAD_BHP(state, value) {
      state.uploadBhp = value
    },
    SET_UPLOAD_OBAT(state, value) {
      state.uploadObat = value
    },
    SET_KLINIK_USER(state, value) {
      state.klinikUser = value
    },
    UPDATE_KLINIK_FOTO(state, value) {
      state.klinikUser.map(data => {
        if (data.id == state.klinikId) {
          data.foto_klinik = value
        }
      });
    },
    SET_DOKTER_ID(state, value) {
      state.dokterId = value
    },
    SET_ROLES(state, value) {
      state.roles = value
    },
    SET_FASKES(state, value) {
      state.faskes = value
    },
    SET_KLINIK_ID(state, value) {
      state.klinikId = value
    },
    SET_BPJS_AUTH_VALID(state, value) {
      state.bpjsAuthValid = value
    },
    SET_SATUSEHAT_AUTH_VALID(state, value) {
      state.satusehatAuthValid = value
    },
    SET_IS_FASKES_DPM(state, value) {
      state.isFaskesDpm = value
    },
    SET_VERIFICATION_PROFILE_ID(state, value) {
      state.verificationProfileId = value
    }
  },
  strict: process.env.NODE_ENV !== "production",
  plugins: [vuexPersist.plugin]
});
